// import { Col, Modal, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
// import SbCancelBtn, { SBSaveUpdateBtn } from "../Buttons/Buttons";
// import { useRef, useState } from "react";
// import downloadImg from '../../assets/images/Dashboard/downloadImg.svg'
// import { baseURL } from "../BaseUrl";
// import * as HeaderAuthentication from '../HeaderAuthentication';

// const ViewComplaints = (props) => {

//     const singleComplaintEscalationData = props.singleComplaintEscalationData[0];
//     const [selectedFile, setSelectedFile] = useState(null);
//     const fileInputRef = useRef(null);

//     // Handle file selection
//     const handleFileChange = (event) => {
//         const file = event.target.files[0];
//         if (file) {
//             setSelectedFile(file);
//             console.log('Selected file:', file);
//         }
//     };

//     // Trigger file input click when attachment button is clicked
//     const handleAttachmentClick = () => {
//         fileInputRef.current.click();
//     };
//     const renderTextWithTooltip = (text) => {
//         // Check if the text length exceeds 24 characters
//         if (text && text.length > 24) {
//             return (
//                 <OverlayTrigger
//                     placement="top"
//                     overlay={<Tooltip>{text}</Tooltip>}
//                 >
//                     <span>{text.substring(0, 24)}...</span>
//                 </OverlayTrigger>
//             );
//         }
//         return <span>{text}</span>;
//     };


//     const downloadFile = () => {
//         const { ComplaintsID, AttachedFileName } = singleComplaintEscalationData;

//         if (ComplaintsID && AttachedFileName) {
//             // Format the URL with query parameters
//             const url = `${baseURL}/complaintservices/api/Complaint/DownloadFile?ComplaintID=${ComplaintsID}&FileName=${encodeURIComponent(AttachedFileName)}`;

//             // Make the GET request
//             fetch(url, HeaderAuthentication.getRequestOptions)
//                 .then((resp) => resp.blob()) // Assuming the file is returned as a Blob
//                 .then((blob) => {
//                     // Create a link to download the file
//                     const link = document.createElement("a");
//                     link.href = URL.createObjectURL(blob);
//                     link.download = AttachedFileName; // Set the file name for download
//                     link.click(); // Trigger the download
//                 })
//                 .catch((err) => {
//                     console.error("File download failed:", err);
//                 });
//         } else {
//             console.error("Invalid file data");
//         }
//     };

//     return (
//         <>
//             <Modal show={props.viewComplaintModal} onHide={props.handleCloseViewModal} className='add-customer-modal add-user-modal'>
//                 <Modal.Header closeButton>
//                     <Modal.Title>View Complaints</Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body>
//                     <Row className='customer-form-fields'>
//                         <Col>
//                             <Row>
//                                 <Col md={4}>
//                                     <div className="view-sla-data">
//                                         <label>Ticket Type</label>
//                                         <span>{renderTextWithTooltip(singleComplaintEscalationData?.TicketType)}</span>
//                                     </div>
//                                     <hr />
//                                 </Col>
//                                 <Col md={4}>
//                                     <div className="view-sla-data">
//                                         <label>Company Name</label>
//                                         <span>{renderTextWithTooltip(singleComplaintEscalationData?.CompanyName)}</span>
//                                     </div>
//                                     <hr />
//                                 </Col>
//                                 <Col md={4}>
//                                     <div className="view-sla-data">
//                                         <label>Reported by</label>
//                                         <span>{renderTextWithTooltip(singleComplaintEscalationData?.ReportedByUser)}</span>
//                                     </div>
//                                     <hr />
//                                 </Col>
//                             </Row>
//                             <Row>
//                                 <Col md={4}>
//                                     <div className="view-sla-data">
//                                         <label>Branch</label>
//                                         <span>{renderTextWithTooltip(singleComplaintEscalationData?.BranchName)}</span>
//                                     </div>
//                                     <hr />
//                                 </Col>
//                                 <Col md={4}>
//                                     <div className="view-sla-data">
//                                         <label>Priority</label>
//                                         <span>{renderTextWithTooltip(singleComplaintEscalationData?.Priority)}</span>
//                                     </div>
//                                     <hr />
//                                 </Col>
//                                 <Col md={4}>
//                                     <div className="view-sla-data">
//                                         <label>Issue Type</label>
//                                         <span>{renderTextWithTooltip(singleComplaintEscalationData?.IssueType)}</span>
//                                     </div>
//                                     <hr />
//                                 </Col>
//                             </Row>
//                             <Row>
//                                 <Col md={4}>
//                                     <div className="view-sla-data">
//                                         <label>Email</label>
//                                         <span className="description-text">{renderTextWithTooltip(singleComplaintEscalationData?.Email)}</span>
//                                     </div>
//                                     <hr />
//                                 </Col>
//                                 <Col md={4}>
//                                     <div className="view-sla-data">
//                                         <label>Contact</label>
//                                         <span>{renderTextWithTooltip(singleComplaintEscalationData?.ContactNo)}</span>
//                                     </div>
//                                     <hr />
//                                 </Col>
//                                 <Col md={4}>
//                                     <div className="view-sla-data">
//                                         <label>Zip Code</label>
//                                         <span>{renderTextWithTooltip(singleComplaintEscalationData?.ZIPCode)}</span>
//                                     </div>
//                                     <hr />
//                                 </Col>
//                             </Row>
//                             <Row>
//                                 <Col md={12}>
//                                     <div className="view-sla-data">
//                                         <label>Address</label>
//                                         <span className="description-text">{renderTextWithTooltip(singleComplaintEscalationData?.Address)}</span>
//                                     </div>
//                                     <hr />
//                                 </Col>
//                             </Row>
//                             <Row>
//                                 <Col md={4}>
//                                     <div className="view-sla-data">
//                                         <label>Assigned To</label>
//                                         <span>{renderTextWithTooltip(singleComplaintEscalationData?.AssignedToUser)}</span>
//                                     </div>
//                                     <hr />
//                                 </Col>
//                                 <Col md={4}>
//                                     <div className="view-sla-data">
//                                         <label>TAT</label>
//                                         <span>{renderTextWithTooltip(singleComplaintEscalationData?.TATInDays)} Day(s)</span>
//                                     </div>
//                                     <hr />
//                                 </Col>
//                                 <Col md={4} className="d-flex flex-column">
//                                     <div className="d-flex justify-content-start align-items-center">
//                                         <div className="dropdown add-single-bulk attachment-section">
//                                             {/* <label>&nbsp;</label> */}
//                                             <button
//                                                 className="download-document-btn"
//                                                 id="adduser-single-blulk"
//                                             >
//                                                 <div className="ps-2">
//                                                     <span>File Name</span>
//                                                     <div className="attachment-note">
//                                                         <small>(5MB)</small>
//                                                     </div>
//                                                 </div>
//                                                 <img src={downloadImg} alt="" className="download-img" onClick={downloadFile} />
//                                             </button>
//                                             {/* {selectedFile && <div className="attachment-note"><small>{selectedFile.name}</small></div>} */}
//                                         </div>
//                                     </div>
//                                     <small>{renderTextWithTooltip(singleComplaintEscalationData?.AttachedFileName)} </small>
//                                 </Col>
//                             </Row>
//                             <Row>
//                                 <Col md={12}>
//                                     <div className='add-customer-calendar-container view-sla-data'>
//                                         <label>Status</label>
//                                         <span>{renderTextWithTooltip(singleComplaintEscalationData?.Status)}</span>
//                                     </div>
//                                     <hr />
//                                 </Col>
//                             </Row>
//                             <Row>
//                                 <Col md={12}>
//                                     <div className="view-sla-data">
//                                         <label>Feedback</label>
//                                         <span className="description-text">{renderTextWithTooltip(singleComplaintEscalationData?.Remarks)}</span>
//                                     </div>
//                                     <hr />
//                                 </Col>
//                             </Row>
//                         </Col>
//                     </Row>

//                 </Modal.Body >
//                 <Modal.Footer>
//                     <SbCancelBtn btnName="Cancel" onClickEffect={props.handleCloseViewModal} />
//                     <SBSaveUpdateBtn btnName="Ok" />
//                 </Modal.Footer>
//             </Modal >
//         </>
//     );
// }

// export default ViewComplaints;






import React, { useEffect } from 'react';
import { Col, Row, ListGroup, Accordion } from "react-bootstrap";
import Main from "../Main";
import customerImg from '../../assets/images/CustomerManagement/customer-img.svg';
import Download from '../MainSection/Download/Download';
import { useDispatch, useSelector } from 'react-redux';
import { loadComplaintEscalationHistoryData } from '../../redux/action';
import { useNavigate, useParams } from 'react-router-dom';
import moment from 'moment'; // To format dates
import downloadImg from '../../assets/images/Dashboard/downloadImg.svg'
import { baseURL } from "../BaseUrl";
import * as HeaderAuthentication from '../HeaderAuthentication';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { Document, Packer, Paragraph, Table, TableCell, TableRow } from "docx";
import { saveAs } from "file-saver";
import html2canvas from 'html2canvas';
import JSZip from "jszip";
import ExcelJS from "exceljs";

const ViewComplaints = ({ handleAnalyticsClick, setShowCustomerViewDetails }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { id: complaintId } = useParams(); // Extract complaint ID from URL

    useEffect(() => {
        if (complaintId) {
            dispatch(loadComplaintEscalationHistoryData(complaintId));
        }
    }, [complaintId, dispatch]);

    const { complaintEscalationHistoryData } = useSelector((state) => state.data);

    const handleBack = () => {
        // setShowCustomerViewDetails(false);
        let moduleId = 5;
        navigate('/complaint', { state: { moduleId } })
    };

    const downloadFile = () => {
        const { ComplaintsID, UserUploadedFileName } = complaintEscalationHistoryData;

        if (ComplaintsID && UserUploadedFileName) {
            // Format the URL with query parameters
            const url = `${baseURL}/complaintservices/api/Complaint/DownloadFile?ComplaintID=${ComplaintsID}&FileName=${encodeURIComponent(UserUploadedFileName)}`;

            // Make the GET request
            fetch(url, HeaderAuthentication.getRequestOptions)
                .then((resp) => resp.blob()) // Assuming the file is returned as a Blob
                .then((blob) => {
                    // Create a link to download the file
                    const link = document.createElement("a");
                    link.href = URL.createObjectURL(blob);
                    link.download = UserUploadedFileName; // Set the file name for download
                    link.click(); // Trigger the download
                })
                .catch((err) => {
                    console.error("File download failed:", err);
                });
        } else {
            console.error("Invalid file data");
        }
    };

    const downloadStatusHistoryFile = (complaintsID, statusChangeFileName) => {
        if (complaintsID && statusChangeFileName) {
            const url = `${baseURL}/complaintservices/api/Complaint/DownloadFile?ComplaintID=${complaintsID}&FileName=${encodeURIComponent(statusChangeFileName)}`;

            fetch(url, HeaderAuthentication.getRequestOptions)
                .then((resp) => {
                    if (!resp.ok) {
                        throw new Error(`HTTP error! Status: ${resp.status}`);
                    }
                    return resp.blob();
                })
                .then((blob) => {
                    const link = document.createElement("a");
                    link.href = URL.createObjectURL(blob);
                    link.download = statusChangeFileName;
                    // document.body.appendChild(link);
                    link.click();
                    // document.body.removeChild(link);
                })
                .catch((err) => {
                    console.error("File download failed:", err);
                });
        } else {
            console.error("Invalid file data: Missing StatusChangeFileName or ComplaintID");
        }
    };

    const handleDownloadExcel = async () => {
        if (!complaintEscalationHistoryData) {
            console.error("No data available for download.");
            return;
        }

        const { ComplaintsID, UserUploadedFileName, ComplaintStatusChangeHistory } = complaintEscalationHistoryData;
        const zip = new JSZip();
        let hasFiles = false;

        /** -------------------- 🟢 Prepare Main Complaint Data -------------------- */
        const headers = [
            "Complaint No", "Ticket Type", "Date", "Company", "Reported By", "Branch",
            "Email", "Contact", "Priority", "Assigned To", "TAT", "Issue Type", "Status"
        ];

        const mainData = [
            [
                ComplaintsID || "NA",
                complaintEscalationHistoryData.TicketType || "NA",
                moment(complaintEscalationHistoryData.ReportedDate).format("YYYY-MM-DD HH:mm") || "NA",
                complaintEscalationHistoryData.CompanyName || "NA",
                complaintEscalationHistoryData.ReportedByUser || "NA",
                complaintEscalationHistoryData.BranchName || "NA",
                complaintEscalationHistoryData.Email || "NA",
                complaintEscalationHistoryData.ContactNo || "NA",
                complaintEscalationHistoryData.Priority || "NA",
                complaintEscalationHistoryData.AssignedToUser || "NA",
                complaintEscalationHistoryData.TATInDays || "NA",
                complaintEscalationHistoryData.IssueType || "NA",
                complaintEscalationHistoryData.Status || "NA"
            ]
        ];

        /** -------------------- 🟢 Prepare Status Change History Data -------------------- */
        const statusHeaders = [
            "#", "Changed By", "Changed On", "From Status", "To Status", "Remark", "Attachment"
        ];

        const statusHistoryData = ComplaintStatusChangeHistory?.length > 0
            ? ComplaintStatusChangeHistory.map((history, index) => ([
                index + 1,
                history.StatusChangedByUser || "NA",
                moment(history.StatusChangedOn).format("YYYY-MM-DD HH:mm") || "NA",
                history.StatusChangedFrom || "NA",
                history.StatusChangedTo || "NA",
                history.Remarks || "NA",
                history.StatusChangeFileName || "NA"
            ]))
            : [["No status change history available"]];

        /** -------------------- 🟢 Create Excel File with Formatting -------------------- */
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Complaint_History");

        // Auto-adjust column widths
        // worksheet.columns = headers.map(header => ({ header, width: header.length + 5 }));

        // Add Complaint Details Title
        worksheet.addRow(["Complaint Details"]).font = { bold: true, size: 14 };

        // Add Headers with Styling
        const headerRow = worksheet.addRow(headers);
        headerRow.eachCell((cell) => {
            cell.font = { bold: true, color: { argb: "FFFFFF" } };
            cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "007ACC" } }; // Blue background
            cell.alignment = { horizontal: "center", vertical: "middle" };
        });

        // Add Main Data
        mainData.forEach(row => worksheet.addRow(row));

        worksheet.addRow([]); // Empty row for spacing

        // Add Status Change History Title
        worksheet.addRow(["Status Change History"]).font = { bold: true, size: 14 };

        // Add Status Headers with Styling
        const statusHeaderRow = worksheet.addRow(statusHeaders);
        statusHeaderRow.eachCell((cell) => {
            cell.font = { bold: true, color: { argb: "FFFFFF" } };
            cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "00C851" } }; // Green background
            cell.alignment = { horizontal: "center", vertical: "middle" };
        });

        // Add Status Change Data
        statusHistoryData.forEach(row => worksheet.addRow(row));

        // Auto-adjust columns based on content
        worksheet.columns.forEach((column) => {
            let maxLength = 0;
            column.eachCell({ includeEmpty: true }, (cell) => {
                const cellValue = cell.value ? cell.value.toString() : "";
                maxLength = Math.max(maxLength, cellValue.length);
            });
            column.width = maxLength + 2; // Add extra space
        });

        // Convert to Buffer and Zip File
        const buffer = await workbook.xlsx.writeBuffer();
        zip.file(`complaint_history_${ComplaintsID}.xlsx`, buffer);
        hasFiles = true;

        /** -------------------- 🟢 Download Attachments -------------------- */
        if (UserUploadedFileName) {
            await downloadAndAddToZip(zip, ComplaintsID, UserUploadedFileName);
            hasFiles = true;
        }

        if (ComplaintStatusChangeHistory?.length > 0) {
            for (const history of ComplaintStatusChangeHistory) {
                if (history.StatusChangeFileName) {
                    await downloadAndAddToZip(zip, ComplaintsID, history.StatusChangeFileName);
                    hasFiles = true;
                }
            }
        }

        /** -------------------- 🟢 Generate ZIP and Download -------------------- */
        if (hasFiles) {
            zip.generateAsync({ type: "blob" }).then(content => {
                saveAs(content, `Complaint_Attachments_${ComplaintsID}.zip`);
            });
        }
    };

    /** 🔹 Function to Download & Add File to ZIP */
    const downloadAndAddToZip = async (zip, complaintsID, fileName) => {
        const url = `${baseURL}/complaintservices/api/Complaint/DownloadFile?ComplaintID=${complaintsID}&FileName=${encodeURIComponent(fileName)}`;

        try {
            const response = await fetch(url, HeaderAuthentication.getRequestOptions);
            if (!response.ok) {
                console.warn(`Failed to download: ${fileName}`);
                return;
            }

            const blob = await response.blob();
            zip.file(fileName, blob);
        } catch (error) {
            console.error(`Error downloading ${fileName}:`, error);
        }
    };

    const handleDownloadPDF = async () => {
        if (!complaintEscalationHistoryData) {
            console.error("No data available for download.");
            return;
        }

        const { ComplaintsID, UserUploadedFileName, ComplaintStatusChangeHistory } = complaintEscalationHistoryData;
        const zip = new JSZip();
        let hasFiles = false;

        /** -------------------- 🟢 Create PDF File -------------------- */
        const doc = new jsPDF({ orientation: 'landscape' });

        // Title
        doc.setFontSize(18);
        doc.text("Complaint Escalation History", 14, 20);

        // Prepare main complaint details
        const mainDetails = [
            ["Complaint No", ComplaintsID || "NA"],
            ["Ticket Type", complaintEscalationHistoryData.TicketType || "NA"],
            ["Date", moment(complaintEscalationHistoryData.ReportedDate).format("YYYY-MM-DD HH:mm") || "NA"],
            ["Company", complaintEscalationHistoryData.CompanyName || "NA"],
            ["Reported By", complaintEscalationHistoryData.ReportedByUser || "NA"],
            ["Branch", complaintEscalationHistoryData.BranchName || "NA"],
            ["Email", complaintEscalationHistoryData.Email || "NA"],
            ["Contact", complaintEscalationHistoryData.ContactNo || "NA"],
            ["Priority", complaintEscalationHistoryData.Priority || "NA"],
            ["Assigned To", complaintEscalationHistoryData.AssignedToUser || "NA"],
            ["TAT", complaintEscalationHistoryData.TATInDays || "NA"],
            ["Issue Type", complaintEscalationHistoryData.IssueType || "NA"],
            ["Status", complaintEscalationHistoryData.Status || "NA"],
        ];

        // Add main details to PDF
        doc.autoTable({
            body: mainDetails,
            startY: 30,
            tableWidth: 'auto',
            styles: { fontSize: 10, cellPadding: 3 },
            theme: 'striped',
            columnStyles: { 0: { fontStyle: 'bold', textColor: [22, 160, 133] } },
        });

        // Prepare status change history if available
        if (ComplaintStatusChangeHistory?.length > 0) {
            const statusHistoryData = ComplaintStatusChangeHistory.map((history, index) => ([
                index + 1,
                history.StatusChangedByUser || "NA",
                moment(history.StatusChangedOn).format("YYYY-MM-DD HH:mm") || "NA",
                history.StatusChangedFrom || "NA",
                history.StatusChangedTo || "NA",
                history.Remarks || "NA",
                history.StatusChangeFileName || "NA"
            ]));

            // Add status change history table
            doc.text("Status Change History", 14, doc.autoTable.previous.finalY + 10);
            doc.autoTable({
                head: [["Status Change No", "Changed By", "Changed On", "From Status", "To Status", "Remark", "Attachment"]],
                body: statusHistoryData,
                startY: doc.autoTable.previous.finalY + 15,
                tableWidth: 'auto',
                styles: { fontSize: 8, cellPadding: 2 },
                headStyles: { fillColor: [22, 160, 133], textColor: [255, 255, 255], halign: 'left' },
            });
        }

        // Convert PDF to Blob & Add to ZIP
        const pdfBlob = doc.output("blob");
        zip.file(`complaint_history_${ComplaintsID}.pdf`, pdfBlob);
        hasFiles = true;

        /** -------------------- 🟢 Download & Add Attachments to ZIP -------------------- */
        const fileDownloadPromises = [];

        // Download main complaint attachment
        if (UserUploadedFileName) {
            fileDownloadPromises.push(downloadAndAddToZip(zip, ComplaintsID, UserUploadedFileName));
            hasFiles = true;
        }

        // Download status change attachments
        if (ComplaintStatusChangeHistory?.length > 0) {
            for (const history of ComplaintStatusChangeHistory) {
                if (history.StatusChangeFileName) {
                    fileDownloadPromises.push(downloadAndAddToZip(zip, ComplaintsID, history.StatusChangeFileName));
                    hasFiles = true;
                }
            }
        }

        // Wait for all files to be downloaded
        await Promise.all(fileDownloadPromises);

        /** -------------------- 🟢 Generate ZIP and Download -------------------- */
        if (hasFiles) {
            zip.generateAsync({ type: "blob" }).then(content => {
                saveAs(content, `Complaint_Attachments_${ComplaintsID}.zip`);
            });
        }
    };

    const handleDownloadWord = async () => {
        if (!complaintEscalationHistoryData) {
            console.error("No data available for download.");
            alert("No data to export!");
            return;
        }

        const { ComplaintsID, UserUploadedFileName, ComplaintStatusChangeHistory } = complaintEscalationHistoryData;
        const zip = new JSZip();
        let hasFiles = false;

        /** -------------------- 🟢 Create Word Document -------------------- */
        const headers = [
            "Complaint No", "Ticket Type", "Date", "Company", "Reported By", "Branch",
            "Email", "Contact", "Priority", "Assigned To", "TAT", "Issue Type", "Status"
        ];
        console.log(ComplaintsID, 'ComplaintsID')
        console.log(complaintEscalationHistoryData, 'complaintEscalationHistoryData');

        const mainData = [
            [
                // ComplaintsID || "NA",
                ComplaintsID != null ? ComplaintsID.toString() : "NA",
                complaintEscalationHistoryData.TicketType || "NA",
                moment(complaintEscalationHistoryData.ReportedDate).format("YYYY-MM-DD HH:mm") || "NA",
                complaintEscalationHistoryData.CompanyName || "NA",
                complaintEscalationHistoryData.ReportedByUser || "NA",
                complaintEscalationHistoryData.BranchName || "NA",
                complaintEscalationHistoryData.Email || "NA",
                complaintEscalationHistoryData.ContactNo || "NA",
                complaintEscalationHistoryData.Priority || "NA",
                complaintEscalationHistoryData.AssignedToUser || "NA",
                complaintEscalationHistoryData.TATInDays || "NA",
                complaintEscalationHistoryData.IssueType || "NA",
                complaintEscalationHistoryData.Status || "NA"
            ]
        ];

        const mainTableRows = [
            new TableRow({
                children: headers.map(header => new TableCell({ children: [new Paragraph(header)] }))
            }),
            ...mainData.map(row =>
                new TableRow({
                    children: row.map(cell => new TableCell({ children: [new Paragraph(cell)] }))
                })
            ),
        ];

        let statusChangeTable = null;
        if (ComplaintStatusChangeHistory?.length > 0) {
            const statusHeaders = ["#", "Changed By", "Changed On", "From Status", "To Status", "Remark", "Attachment"];
            const statusHistoryData = ComplaintStatusChangeHistory.map((history, index) => ([
                String(index + 1),
                history.StatusChangedByUser || "NA",
                moment(history.StatusChangedOn).format("YYYY-MM-DD HH:mm") || "NA",
                history.StatusChangedFrom || "NA",
                history.StatusChangedTo || "NA",
                history.Remarks || "NA",
                history.StatusChangeFileName || "NA"
            ]));

            const statusTableRows = [
                new TableRow({
                    children: statusHeaders.map(header => new TableCell({ children: [new Paragraph(header)] }))
                }),
                ...statusHistoryData.map(row =>
                    new TableRow({
                        children: row.map(cell => new TableCell({ children: [new Paragraph(cell)] }))
                    })
                ),
            ];

            statusChangeTable = new Table({ rows: statusTableRows });
        }

        const doc = new Document({
            creator: "Complaint Management System",
            title: "Complaint Escalation Report",
            description: "A detailed report of complaints and escalations.",
            sections: [
                {
                    children: [
                        new Paragraph("Complaint Escalation History"),
                        new Table({ rows: mainTableRows }),
                        statusChangeTable ? new Paragraph("\nStatus Change History") : null,
                        statusChangeTable ? statusChangeTable : null,
                    ].filter(Boolean),
                },
            ],
        });

        const wordBlob = await Packer.toBlob(doc);
        zip.file(`complaint_history_${ComplaintsID}.docx`, wordBlob);
        hasFiles = true;

        /** -------------------- 🟢 Download & Add Attachments to ZIP -------------------- */
        const fileDownloadPromises = [];

        if (UserUploadedFileName) {
            fileDownloadPromises.push(downloadAndAddToZip(zip, ComplaintsID, UserUploadedFileName));
            hasFiles = true;
        }

        if (ComplaintStatusChangeHistory?.length > 0) {
            for (const history of ComplaintStatusChangeHistory) {
                if (history.StatusChangeFileName) {
                    fileDownloadPromises.push(downloadAndAddToZip(zip, ComplaintsID, history.StatusChangeFileName));
                    hasFiles = true;
                }
            }
        }

        await Promise.all(fileDownloadPromises);

        /** -------------------- 🟢 Generate ZIP and Download -------------------- */
        if (hasFiles) {
            zip.generateAsync({ type: "blob" }).then(content => {
                saveAs(content, `Complaint_Attachments_${ComplaintsID}.zip`);
            });
        }
    };

    const handlePrint = async () => {
        if (!complaintEscalationHistoryData) {
            console.error("No data available.");
            alert("No data to process!");
            return;
        }

        const { ComplaintsID, UserUploadedFileName, ComplaintStatusChangeHistory } = complaintEscalationHistoryData;

        /** -------------------- 🟢 Prepare Main Complaint Data -------------------- */
        let mainDetailsHtml = `
            <h1>Complaint Escalation History</h1>
            <table border="1" style="border-collapse: collapse; width: 100%;">
                <tbody>
                    <tr><td><b>Complaint No</b></td><td>${ComplaintsID || "NA"}</td></tr>
                    <tr><td><b>Ticket Type</b></td><td>${complaintEscalationHistoryData.TicketType || "NA"}</td></tr>
                    <tr><td><b>Date</b></td><td>${moment(complaintEscalationHistoryData.ReportedDate).format("YYYY-MM-DD HH:mm") || "NA"}</td></tr>
                    <tr><td><b>Company</b></td><td>${complaintEscalationHistoryData.CompanyName || "NA"}</td></tr>
                    <tr><td><b>Reported By</b></td><td>${complaintEscalationHistoryData.ReportedByUser || "NA"}</td></tr>
                    <tr><td><b>Branch</b></td><td>${complaintEscalationHistoryData.BranchName || "NA"}</td></tr>
                    <tr><td><b>Email</b></td><td>${complaintEscalationHistoryData.Email || "NA"}</td></tr>
                    <tr><td><b>Contact</b></td><td>${complaintEscalationHistoryData.ContactNo || "NA"}</td></tr>
                    <tr><td><b>Priority</b></td><td>${complaintEscalationHistoryData.Priority || "NA"}</td></tr>
                    <tr><td><b>Assigned To</b></td><td>${complaintEscalationHistoryData.AssignedToUser || "NA"}</td></tr>
                    <tr><td><b>TAT</b></td><td>${complaintEscalationHistoryData.TATInDays || "NA"}</td></tr>
                    <tr><td><b>Issue Type</b></td><td>${complaintEscalationHistoryData.IssueType || "NA"}</td></tr>
                    <tr><td><b>Status</b></td><td>${complaintEscalationHistoryData.Status || "NA"}</td></tr>
                </tbody>
            </table>
        `;

        /** -------------------- 🟢 Prepare Status Change History Data -------------------- */
        let statusHistoryHtml = "";
        if (ComplaintStatusChangeHistory?.length > 0) {
            const statusHistoryRows = ComplaintStatusChangeHistory.map((history, index) => `
                <tr>
                    <td>${index + 1}</td>
                    <td>${history.StatusChangedByUser || "NA"}</td>
                    <td>${moment(history.StatusChangedOn).format("YYYY-MM-DD HH:mm") || "NA"}</td>
                    <td>${history.StatusChangedFrom || "NA"}</td>
                    <td>${history.StatusChangedTo || "NA"}</td>
                    <td>${history.Remarks || "NA"}</td>
                    <td>${history.StatusChangeFileName ? `<a href="${history.StatusChangeFileName}" target="_blank">${history.StatusChangeFileName.split('/').pop()}</a>` : "NA"}</td>
                </tr>
            `).join('');

            statusHistoryHtml = `
                <h2>Status Change History</h2>
                <table border="1" style="border-collapse: collapse; width: 100%;">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Changed By</th>
                            <th>Changed On</th>
                            <th>From Status</th>
                            <th>To Status</th>
                            <th>Remark</th>
                            <th>Attachment</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${statusHistoryRows}
                    </tbody>
                </table>
            `;
        }

        /** -------------------- 🟢 Prepare Attachment List -------------------- */
        let attachmentsHtml = "";

        /** -------------------- 🟢 Open Print Window -------------------- */
        const printWindow = window.open('', '', 'width=900,height=700');
        printWindow.document.write(`
            <html>
            <head>
                <title>Complaint History Report</title>
                <style>
                    body { font-family: Arial, sans-serif; margin: 20px; }
                    h1, h2 { color: #333; }
                    table { width: 100%; border-collapse: collapse; margin-top: 10px; }
                    th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
                    th { background-color: #f2f2f2; }
                </style>
            </head>
            <body>
                ${mainDetailsHtml}
                ${statusHistoryHtml ? statusHistoryHtml : '<p>No Status History Available</p>'}
                ${attachmentsHtml}
            </body>
            </html>
        `);
        printWindow.document.close();
        printWindow.print();

        /** -------------------- 🟢 Generate ZIP with Attachments -------------------- */
        const zip = new JSZip();
        let hasFiles = false;

        if (UserUploadedFileName) {
            await downloadAndAddToZip(zip, ComplaintsID, UserUploadedFileName);
            hasFiles = true;
        }

        if (ComplaintStatusChangeHistory?.length > 0) {
            for (const history of ComplaintStatusChangeHistory) {
                if (history.StatusChangeFileName) {
                    await downloadAndAddToZip(zip, ComplaintsID, history.StatusChangeFileName);
                    hasFiles = true;
                }
            }
        }

        if (hasFiles) {
            zip.generateAsync({ type: "blob" }).then(content => {
                saveAs(content, `Complaint_Attachments_${ComplaintsID}.zip`);
            });
        }
    };

    const handleDownloadImage = async () => {
        if (!complaintEscalationHistoryData) {
            console.error("No data available for exporting.");
            alert("No data to export!");
            return;
        }

        const zip = new JSZip();
        let hasFiles = false;

        /** -------------------- 🟢 Create Image of Complaint Details -------------------- */
        const imageContainer = document.createElement("div");
        imageContainer.style.position = "absolute";
        imageContainer.style.left = "-9999px"; // Hide the container off-screen

        imageContainer.innerHTML = `
            <div style="font-family: Arial, sans-serif; padding: 20px;">
                <h4 style="text-align: center;">Complaint Escalation History</h4>
                <h5>Complaint Details</h5>
                <table border="1" style="border-collapse: collapse; width: 100%; font-family: Arial, sans-serif;">
                    <tbody>
                        <tr><td style="padding: 8px; font-weight: bold;">Complaint No</td><td style="padding: 8px;">${complaintEscalationHistoryData.ComplaintsID || "NA"}</td></tr>
                        <tr><td style="padding: 8px; font-weight: bold;">Ticket Type</td><td style="padding: 8px;">${complaintEscalationHistoryData.TicketType || "NA"}</td></tr>
                        <tr><td style="padding: 8px; font-weight: bold;">Date</td><td style="padding: 8px;">${complaintEscalationHistoryData.ReportedDate ? moment(complaintEscalationHistoryData.ReportedDate).format("YYYY-MM-DD HH:mm") : "NA"}</td></tr>
                        <tr><td style="padding: 8px; font-weight: bold;">Company</td><td style="padding: 8px;">${complaintEscalationHistoryData.CompanyName || "NA"}</td></tr>
                        <tr><td style="padding: 8px; font-weight: bold;">Reported By</td><td style="padding: 8px;">${complaintEscalationHistoryData.ReportedByUser || "NA"}</td></tr>
                        <tr><td style="padding: 8px; font-weight: bold;">Branch</td><td style="padding: 8px;">${complaintEscalationHistoryData.BranchName || "NA"}</td></tr>
                        <tr><td style="padding: 8px; font-weight: bold;">Email</td><td style="padding: 8px;">${complaintEscalationHistoryData.Email || "NA"}</td></tr>
                        <tr><td style="padding: 8px; font-weight: bold;">Contact</td><td style="padding: 8px;">${complaintEscalationHistoryData.ContactNo || "NA"}</td></tr>
                        <tr><td style="padding: 8px; font-weight: bold;">Priority</td><td style="padding: 8px;">${complaintEscalationHistoryData.Priority || "NA"}</td></tr>
                        <tr><td style="padding: 8px; font-weight: bold;">Assigned To</td><td style="padding: 8px;">${complaintEscalationHistoryData.AssignedToUser || "NA"}</td></tr>
                        <tr><td style="padding: 8px; font-weight: bold;">TAT</td><td style="padding: 8px;">${complaintEscalationHistoryData.TATInDays || "NA"}</td></tr>
                        <tr><td style="padding: 8px; font-weight: bold;">Issue Type</td><td style="padding: 8px;">${complaintEscalationHistoryData.IssueType || "NA"}</td></tr>
                        <tr><td style="padding: 8px; font-weight: bold;">Status</td><td style="padding: 8px;">${complaintEscalationHistoryData.Status || "NA"}</td></tr>
                    </tbody>
                </table>
            </div>
        `;

        /** -------------------- 🟢 Prepare Status Change History Data -------------------- */
        const statusHistory = complaintEscalationHistoryData?.ComplaintStatusChangeHistory || [];
        let statusHistoryHtml = "";

        if (statusHistory.length > 0) {
            const statusHistoryRows = statusHistory.map((history, index) => `
                <tr>
                    <td>${index + 1}</td>
                    <td>${history.StatusChangedByUser || "NA"}</td>
                    <td>${history.StatusChangedOn ? moment(history.StatusChangedOn).format("YYYY-MM-DD HH:mm") : "NA"}</td>
                    <td>${history.StatusChangedFrom || "NA"}</td>
                    <td>${history.StatusChangedTo || "NA"}</td>
                    <td>${history.Remarks || "NA"}</td>
                    <td>${history.StatusChangeFileName ? `<a href="${history.StatusChangeFileName}" target="_blank">${history.StatusChangeFileName.split('/').pop()}</a>` : "NA"}</td>
                </tr>
            `).join('');

            statusHistoryHtml = `
                <h5>Status Change History</h5>
                <table border="1" style="border-collapse: collapse; width: 100%;">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Changed By</th>
                            <th>Changed On</th>
                            <th>From Status</th>
                            <th>To Status</th>
                            <th>Remark</th>
                            <th>Attachment</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${statusHistoryRows}
                    </tbody>
                </table>
            `;
        }

        // Append status history to the complaint details
        imageContainer.innerHTML += statusHistoryHtml;
        document.body.appendChild(imageContainer);

        /** -------------------- 🟢 Convert to Image -------------------- */
        const canvas = await html2canvas(imageContainer, {
            scale: 2,
            useCORS: true
        });

        document.body.removeChild(imageContainer); // Clean up
        const imgData = canvas.toDataURL("image/png");

        // Convert image to Blob and add to ZIP
        const response = await fetch(imgData);
        const imgBlob = await response.blob();
        zip.file(`complaint_escalation_history.png`, imgBlob);
        hasFiles = true;

        /** -------------------- 🟢 Download Attachments and Add to ZIP -------------------- */
        if (complaintEscalationHistoryData.UserUploadedFileName) {
            await downloadAndAddToZip(zip, complaintEscalationHistoryData.ComplaintsID, complaintEscalationHistoryData.UserUploadedFileName);
            hasFiles = true;
        }

        if (statusHistory.length > 0) {
            for (const history of statusHistory) {
                if (history.StatusChangeFileName) {
                    await downloadAndAddToZip(zip, complaintEscalationHistoryData.ComplaintsID, history.StatusChangeFileName);
                    hasFiles = true;
                }
            }
        }

        /** -------------------- 🟢 Generate ZIP and Download -------------------- */
        if (hasFiles) {
            zip.generateAsync({ type: "blob" }).then(content => {
                saveAs(content, `Complaint_Attachments_${complaintEscalationHistoryData.ComplaintsID}.zip`);
            });
        }
    };

    return (
        <div className="customer-management-view-details-container">
            <Main>
                <div className='components-download-container'>
                    <Download
                        moduleName="Back"
                        showBackButton={true}
                        showDashboardLibraryButton={false}
                        showSaveCustomViewButton={false}
                        showAnalyticsButton={true}
                        showDownloadDropdown={true}
                        onClick={handleAnalyticsClick}
                        onExcelDownloadClick={handleDownloadExcel}
                        onPdfDownloadClick={handleDownloadPDF}
                        onWordDownloadClick={handleDownloadWord}
                        onPrintClick={handlePrint}
                        onImageClick={handleDownloadImage}
                        onBackClick={handleBack}
                    />
                </div>
                <div className='customermanagement-content-container'>
                    <Row className="customermanagement-view-details-btns-container">
                        {/* Service Request Details */}
                        <Col md={4} className='customermanagement-view-details-first-col'>
                            <div className="customermanagement-view-details-header">
                                <p>Service Request Details</p>
                                <img src={customerImg} alt="Customer" />
                            </div>
                            <ListGroup variant="flush" className='head-quarters-list-items mt-4'>
                                <ListGroup.Item><p>Service Request ID</p><p>: </p><p>{complaintEscalationHistoryData?.ComplaintsID}</p></ListGroup.Item>
                                <ListGroup.Item><p>Ticket Type</p><p>: </p><p>{complaintEscalationHistoryData?.TicketType}</p></ListGroup.Item>
                                <ListGroup.Item><p>Company Name</p><p>: </p><p>{complaintEscalationHistoryData?.CompanyName}</p></ListGroup.Item>
                                <ListGroup.Item><p>Contact Number</p><p>: </p><p>{complaintEscalationHistoryData?.ContactNo}</p></ListGroup.Item>
                                <ListGroup.Item><p>Email ID</p><p>: </p><p>{complaintEscalationHistoryData?.Email}</p></ListGroup.Item>
                                <ListGroup.Item><p>Issue Type</p><p>: </p><p>{complaintEscalationHistoryData?.IssueType}</p></ListGroup.Item>
                                <ListGroup.Item><p>Reported By</p><p>: </p><p>{complaintEscalationHistoryData?.ReportedByUser}</p></ListGroup.Item>
                                <ListGroup.Item><p>Reported Date</p><p>: </p><p>{moment(complaintEscalationHistoryData?.ReportedDate).format("YYYY-MM-DD HH:mm")}</p></ListGroup.Item>
                                <ListGroup.Item><p>Remark</p><p>: </p><p>{complaintEscalationHistoryData?.Remarks}</p></ListGroup.Item>
                                <ListGroup.Item><p>ERT(In Days)</p><p>: </p><p>{complaintEscalationHistoryData?.TATInDays}</p></ListGroup.Item>
                                <ListGroup.Item><p>Assigned To</p><p>: </p><p>{complaintEscalationHistoryData?.AssignedToUser || "NA"}</p></ListGroup.Item>
                                <ListGroup.Item><p>Address</p><p>: </p><p>{complaintEscalationHistoryData?.Address}</p></ListGroup.Item>
                                <ListGroup.Item><p>Status</p><p>: </p><p>{complaintEscalationHistoryData?.Status}</p></ListGroup.Item>

                            </ListGroup>
                            {complaintEscalationHistoryData?.UserUploadedFileName && <Col md={10} className="d-flex flex-column">
                                <div className="d-flex justify-content-start align-items-center">
                                    <div className="dropdown add-single-bulk attachment-section">
                                        {/* <label>&nbsp;</label> */}
                                        <button
                                            className="download-document-btn"
                                            id="adduser-single-blulk"
                                        >
                                            <div className="ps-2">
                                                {/* <span>File Name</span> */}
                                                <div className="attachment-note">
                                                    <small>{complaintEscalationHistoryData?.UserUploadedFileName || "File Not Found"}</small>
                                                </div>
                                            </div>
                                            <img src={downloadImg} alt="" className="download-img" onClick={downloadFile} />
                                        </button>
                                        {/* {selectedFile && <div className="attachment-note"><small>{selectedFile.name}</small></div>} */}
                                    </div>
                                </div>
                                {/* <small>{renderTextWithTooltip(singleComplaintEscalationData?.AttachedFileName)} </small> */}
                            </Col>}
                        </Col>

                        {/* Complaint Status Change History */}
                        <Col md={8}>
                            <div className="customermanagement-view-details-second-header">
                                <p>Service Request Status Change History</p>
                            </div>
                            <Accordion defaultActiveKey="0">
                                {complaintEscalationHistoryData?.ComplaintStatusChangeHistory?.length > 0 ? (
                                    complaintEscalationHistoryData.ComplaintStatusChangeHistory.map((history, index) => (
                                        <Accordion.Item eventKey={index.toString()} key={index}>
                                            <Accordion.Header className='customermanagement-view-accordian-header'>
                                                {history.StatusChangedFrom ? `${history.StatusChangedFrom} → ${history.StatusChangedTo}` : history.StatusChangedTo}
                                            </Accordion.Header>
                                            <Accordion.Body className='customermanagement-accordian-body'>
                                                <Row>
                                                    <Col md={4}>
                                                        <p>Changed By</p>
                                                        <span>{history.StatusChangedByUser || "NA"}</span>
                                                    </Col>
                                                    {/* <Col md={4}>
                                                        <p>From Status</p>
                                                        <span>{history.StatusChangedFrom || "N/A"}</span>
                                                    </Col>
                                                    <Col md={4}>
                                                        <p>To Status</p>
                                                        <span>{history.StatusChangedTo}</span>
                                                    </Col> */}
                                                    <Col md={4}>
                                                        <p>Changed On</p>
                                                        <span>{moment(history.StatusChangedOn).format("YYYY-MM-DD HH:mm") || "NA"}</span>
                                                    </Col>
                                                    <Col md={4}>
                                                        <p>Remark</p>
                                                        <span>{history.Remarks || "NA"}</span>
                                                    </Col>
                                                </Row>
                                                {history?.StatusChangeFileName && <Row className='mt-3'>
                                                    <Col md={6} className="d-flex flex-column">
                                                        <div className="d-flex justify-content-start align-items-center">
                                                            <div className="dropdown add-single-bulk attachment-section">
                                                                {/* <label>&nbsp;</label> */}
                                                                <button
                                                                    className="download-document-btn"
                                                                    id="adduser-single-blulk"
                                                                >
                                                                    <div className="ps-2">
                                                                        {/* <span>File Name</span> */}
                                                                        <div className="attachment-note">
                                                                            <small>{history?.StatusChangeFileName || "File Not Found"}</small>
                                                                        </div>
                                                                    </div>
                                                                    <img src={downloadImg} alt="" className="download-img"
                                                                        //  onClick={downloadStatusHistoryFile}
                                                                        onClick={() => downloadStatusHistoryFile(complaintEscalationHistoryData?.ComplaintsID, history?.StatusChangeFileName)}
                                                                    />
                                                                </button>
                                                                {/* {selectedFile && <div className="attachment-note"><small>{selectedFile.name}</small></div>} */}
                                                            </div>
                                                        </div>
                                                        {/* <small>{renderTextWithTooltip(singleComplaintEscalationData?.AttachedFileName)} </small> */}
                                                    </Col>
                                                </Row>}
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    ))
                                ) : (
                                    <p>No status history available.</p>
                                )}
                            </Accordion>
                        </Col>
                    </Row>
                </div>
            </Main>
        </div>
    );
};

export default ViewComplaints;
